export function GetPriceRule() {
    return new Promise((resolve) =>
        setTimeout(() =>
            resolve(
                fetch(process.env.REACT_APP_API_URL + '/RequestApi/GetPriceRule', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8',
                        'access-control-allow-origin': '*',
                        'Authorization': process.env.REACT_APP_AUTHORIZATION_KEY
                    },
                    credentials: process.env.NODE_ENV !== "production" ? "include" : "same-origin",
                })
                    .then(res => res.json())
                    .then((data) => {
                        return data;
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    })
            )
        ), 0)
}

export function requestOTP(data) {
    return new Promise((resolve) =>
        setTimeout(() =>
            resolve(
                fetch(process.env.REACT_APP_API_URL + '/SessionApi/RequestOtp', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8',
                        'access-control-allow-origin': '*',
                        'Authorization': process.env.REACT_APP_AUTHORIZATION_KEY
                    },
                    credentials: process.env.NODE_ENV !== "production" ? "include" : "same-origin",
                    body: JSON.stringify(data)
                })
                    .then(async res => {
                        // Check if the response has a body
                        const contentType = res.headers.get('content-type');
                        if (!contentType || !contentType.includes('application/json')) {
                            // No JSON response, return null or do something else
                            return {
                                resStatusCode: res.status,
                            };
                        } 
                        return await res.json()
                    })
                    .then((data) => {
                        return data;
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    })
            )
        ), 0)
}

export function ValidateOTP(data) {
    return new Promise((resolve) =>
        setTimeout(() =>
            resolve(
                fetch(process.env.REACT_APP_API_URL + '/RequestApi/ValidateOTP', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8',
                        'access-control-allow-origin': '*',
                        'Authorization': process.env.REACT_APP_AUTHORIZATION_KEY
                    },
                    credentials: process.env.NODE_ENV !== "production" ? "include" : "same-origin",
                    body: JSON.stringify(data)
                })
                    .then(res => res.json())
                    .then((data) => {
                        return data;
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    })
            )
        ), 0)
}

export function CartCheckout(data) {
    return new Promise((resolve) =>
        setTimeout(() =>
            resolve(
                fetch(process.env.REACT_APP_API_URL + '/CartReproApi/CheckOut', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8',
                        'access-control-allow-origin': '*',
                        'Authorization': process.env.REACT_APP_AUTHORIZATION_KEY
                    },
                    credentials: process.env.NODE_ENV !== "production" ? "include" : "same-origin",
                    body: JSON.stringify(data)
                })
                    .then(res => res.json())
                    .then((data) => {
                        return data;
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    })
            )
        ), 0)
}

export function RegisterPayment(data) {
    return new Promise((resolve) =>
        setTimeout(() =>
            resolve(
                fetch(process.env.REACT_APP_API_URL + '/PaymentApi/RegisterPayment', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8',
                        'access-control-allow-origin': '*',
                        'Authorization': process.env.REACT_APP_AUTHORIZATION_KEY
                    },
                    credentials: process.env.NODE_ENV !== "production" ? "include" : "same-origin",
                    body: JSON.stringify(data)
                })
                    .then(res => res.json())
                    .then((data) => {
                        return data;
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    })
            )
        ), 0)
}

export function GetCartItems(data) {
    return new Promise((resolve) =>
        setTimeout(() =>
            resolve(
                fetch(process.env.REACT_APP_API_URL + '/CartReproApi/GetCartItems?shopCode=' + data.ShopCode, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8',
                        'access-control-allow-origin': '*',
                        'Authorization': process.env.REACT_APP_AUTHORIZATION_KEY
                    },
                    credentials: process.env.NODE_ENV !== "production" ? "include" : "same-origin",
                })
                    .then(res => res.json())
                    .then((data) => {
                        return data;
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    })
            )
        ), 0)
}
export const GetCheckoutObj = data => Object.assign({}, RegisterReproductionRequest, data);
export const GetCartItemRequestObj = data => Object.assign({}, CartItemRequest, data);

const CartItemRequest = {
    CartItemId: null,
    FullOrPartial: null, // Full or Partial
    Format: null,
    StartTime: 0,
    EndTime: 0,
    FirstWords: null,
    LastWords: null,
    Pages: null
};

export const RegisterReproductionRequest = {
    ShopCode: null,
    RequestorName: null,
    RequestorEmail: null,
    RequestorMobile: null,
    Nationality: null,
    UserTypeCode: null,
    OrganisationName: null,
    COUCode: null,
    ResearchTopic: null,
    Remarks: null,
    CookieId: null,
    CartItems: null,
    GroupAmount: null,
    ItemAmount: null,
    TotalAmount: null
};
// export function GetCartItems(data) {
//     return new Promise((resolve) =>
//         setTimeout(() =>
//             resolve(
//                 fetch(data.ShopCode === "C" ? './JSON/cartItem2a.json' : './JSON/cartItem2p.json', {
//                     method: 'GET',
//                     headers: {
//                         'Content-Type': 'application/json; charset=utf-8',
//                         'access-control-allow-origin': '*',
//                         'Authorization': process.env.REACT_APP_AUTHORIZATION_KEY
//                     }
//                 })
//                     .then(res => res.json())
//                     .then((data) => {
//                         return data;
//                     })
//                     .catch((error) => {
//                         console.error('Error:', error);
//                     })
//             )
//         ), 0)
// }

export function ValidateEmail(data) {
    return new Promise((resolve) =>
        setTimeout(() =>
            resolve(
                fetch(process.env.REACT_APP_API_URL + '/RequestApi/ValidateEmail', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8',
                        'access-control-allow-origin': '*',
                        'Authorization': process.env.REACT_APP_AUTHORIZATION_KEY
                    },
                    body: JSON.stringify(data)
                })
                    .then(res => res.json())
                    .then((data) => {
                        return data;
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    })
            )
        ), 0)
}